export const BUSINESS_RELATIONSHIPS = [
  'owner', 'co_owner', 'partner', 'director', 'operator',
  'authorized_representative', 'accountant', 'payer',
];

export const BUSINESS_REQUEST_SCOPES = [
  'view', 'pay', 'view_receipts', 'download_receipts', 'manage_profile', 'manage_tax', 'submit_documents', 'submit_tax_declaration',
];

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const TENANT_SLUG_PATTERN = /^[a-z0-9][a-z0-9-]{1,98}[a-z0-9]$/;

export const initialMembershipRequest = () => ({
  tenant_slug: '',
  business_uid: '',
  requested_relationship: 'owner',
  requested_scopes: ['view', 'pay', 'view_receipts', 'download_receipts', 'submit_tax_declaration'],
  note: '',
  attestation: false,
});

export const membershipRequestPayload = values => {
  const tenantSlug = String(values?.tenant_slug || '').trim().toLowerCase();
  const businessUid = String(values?.business_uid || '').trim().toLowerCase();
  const relationship = String(values?.requested_relationship || '').trim();
  const scopes = [...new Set(values?.requested_scopes || [])];
  const note = String(values?.note || '').trim();
  if (!TENANT_SLUG_PATTERN.test(tenantSlug)) throw new Error('Enter a valid Gram Panchayat slug.');
  if (!UUID_PATTERN.test(businessUid)) throw new Error('Enter the stable Business UID from that Gram Panchayat.');
  if (!BUSINESS_RELATIONSHIPS.includes(relationship)) throw new Error('Choose a valid business relationship.');
  if (!scopes.length || scopes.some(scope => !BUSINESS_REQUEST_SCOPES.includes(scope))) throw new Error('Choose at least one supported access scope.');
  if (note.length < 3) throw new Error('Explain the business relationship in at least 3 characters.');
  if (values?.attestation !== true) throw new Error('Accept the evidence attestation before submitting.');
  return {
    tenant_slug: tenantSlug,
    business_uid: businessUid,
    requested_relationship: relationship,
    requested_scopes: scopes,
    evidence: { note, attestation: true },
  };
};

export const latestMembershipClaim = request => (request?.claims || [])[0] || null;
